<div class="container-capped-sm px-0 d-flex " [class.h-min-full-header]="!inline">
  <div *ngIf="!sharedService.isBrowser" class="container-capped text-center align-self-center">
    <img class="w-100" src="/assets/images/KarpisheLogo.svg" alt="کارپیشه">
  </div>
  <section *ngIf="sharedService.isBrowser" class="w-100 relative" [class.py-2]="!inline" [class.px-0]="inline">
    <ngx-spinner name="login" [fullScreen]="false" type="timer"></ngx-spinner>
    <h1 class="kp-title-line h2" *ngIf="heading">{{heading}}</h1>
    <form (submit)="Utility.validate(loginForm) && authenticate()" *ngIf="!authSent" #loginForm="ngForm">
      <ng-container *ngIf="!withPassword">
        <div class="{{flat? '' : 'kp-card f-initial p-3 mx-0'}}">
          <h6>شماره موبایل:</h6>
          <div *ngIf="intro">{{intro}}</div>
          <div class="py-3">
            <input type="tel" dir="ltr" autocomplete="mobile" name="mobile" required [pattern]="patterns.mobile"
              placeholder="مثل: 09123456789" [(ngModel)]="mobile" [attr.autofocus]="autoFocus">
          </div>
        </div>
        <div>
          <button class="btn btn-primary w-100" [class.disabled]="loginForm.invalid || authSent!=false"
            containerClass="tooltip-warning" triggers="focus"
            [tooltip]="loginForm.invalid ? 'شماره موبایل خود را با ارقام انگلیسی و کامل وارد کنید':undefined">
            {{loginText}}</button>
        </div>
        <!-- enable for enamad -->
        <!-- <div *ngIf="isMainComponent" class="btn btn-link f-blue" (click)="withPassword=true">ورود با نام‌کاربری و کلمه‌عبور</div> -->
      </ng-container>
      <ng-container *ngIf="withPassword">
        <div class="{{flat? '' : 'kp-card f-initial p-3 mx-0'}}">
          <h6>نام‌ کاربری یا شماره‌ موبایل:</h6>
          <input type="text" dir="ltr" autocomplete="username" name="username" required [(ngModel)]="mobile"
            [attr.autofocus]="autoFocus">
          <h6>کلمه‌ عبور:</h6>
          <input type="password" dir="ltr" autocomplete="current-password" name="password" required
            [(ngModel)]="password">
        </div>
        <div>
          <button class="btn btn-primary w-100" [class.disabled]="loginForm.invalid || authSent!=false"
            containerClass="tooltip-warning" triggers="focus"
            [tooltip]="loginForm.invalid ? 'نام کاربری و کلمه عبور خود را وارد کنید':undefined">
            ورود</button>
        </div>
        <div class="btn btn-link f-blue" (click)="withPassword=false">ورود با شماره موبایل</div>
      </ng-container>
    </form>

    <form *ngIf="authSent && !checkConfirmCode" (submit)="confirmForm.valid && confirm()" #confirmForm="ngForm">
      <div class="{{flat? '' : 'kp-card f-initial p-3 mx-0'}} my-2">
        <div class="pb-2" *ngIf="newUser && showNameInput">
          <label>
            <div>
              نام و نام خانوادگی خودت رو وارد کن
            </div>
            <div class="d-flex">
              <input type="text" name="firstname" [(ngModel)]="info.firstname" placeholder="اسم"
                class="form-control ml-1">
              <input type="text" name="lastname" [(ngModel)]="info.lastname" placeholder="فامیل"
                class="form-control mr-1">
            </div>
          </label>
        </div>
        <div>
          <div class="">کد پیامک شده به {{mobile}} را وارد کن</div>
          <div class="py-2 text-center">
            <input class="w-50 no-spinner text-center " type="text" inputmode="numeric" kp-numeric min="1000" max="9999"
              step="1" id="auth-code" name="auth-code" required pattern="^[0-9]{4,}" minlength="4" placeholder="****"
              [(ngModel)]="authCode" autocomplete="one-time-code"
              (input)="(!newUser || !showNameInput) && $event.target.value.length==4 && confirm()" />
          </div>
        </div>
        <div class="">
          <div class="text-center">
            <button class="btn btn-link btn-sm fs-sm" type="button" [disabled]="resendRemain|async"
              (click)="authenticate()">
              <i class="fa fa-redo ml-1"></i>
              ارسال دوباره
              <ng-container *ngIf="resendRemain|async"> ({{resendRemain|async}} ثانیه)</ng-container>
            </button>
          </div>
          <div class="text-center">
            <button class="btn btn-primary btn-sm fs-sm" type="button"
              [class.invisible]="authCode || (checkConfirmRemain|async)" (click)="startCheckConfirm()">
              اگر پیامک نرسید، این دکمه را بزن
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center py-1">
        <div>
          <button type="button" class="btn btn-secondary ml-2" (click)="makeReady()">اصلاح شماره</button>
        </div>
        <div class="flex-grow-1">
          <button class="btn btn-primary w-100" type="submit" [class.disabled]="confirmForm.invalid"
            containerClass="tooltip-warning " triggers="focus" tabindex="0"
            [tooltip]="confirmForm.invalid ? 'کد تایید رو با ارقام انگلیسی و کامل وارد کن':undefined">ثبت کد
            تایید</button>
        </div>
      </div>

    </form>

    <div *ngIf="authSent && checkConfirmCode" class="px-3">
      <div class="{{flat? '' : 'kp-card f-initial p-3 mx-0'}} my-2 text-center">
        <div>
          لطفا کد <span class="bold fs-xl">{{checkConfirmCode}}</span> رو از شماره {{mobile}} به شماره
          <a [sms-to]="smsReceiver" [sms-body]="checkConfirmCode">{{smsReceiver}}</a> پیامک کنید.
        </div>
        <div class="p-2">
          <a class="btn btn-primary w-100" [sms-to]="smsReceiver" [sms-body]="checkConfirmCode">ارسال پیامک</a>
        </div>
        <div class="f-green">پس از ارسال پیامک به همین صفحه برگردید.<br />شما به صورت خودکار به سامانه وارد خواهید شد.
        </div>
      </div>
      <div class="d-flex align-items-center py-1">
        <div>
          <button type="button" class="btn btn-secondary ml-2" (click)="makeReady()">اصلاح شماره</button>
        </div>
      </div>

    </div>
  </section>
</div>